module.exports = __webpack_public_path__ + "fonts/UcCo3FwrK3iLTcvuYwYZ8UA3J58.b3ff444.woff2";